export default {
  name: "LCA Preparer",
  pageInfo: {
    text:
      "Complete this section if the preparer of this LCA is a person other than the one identified in either Section D (employer point of contact) or E (attorney or agent) of this application.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "K.1",
          machine_name: "k1_prep_last",
          widget: "text",
          label: "Last (family) Name",
          validate: [
            {
              valueChecker: "k1_prep_last",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: ["k1_prep_last", "k2_prep_first", "k3_prep_middle", "k4_prep_firm_name", "k5_prep_email"],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the last (family) name of the person preparing this LCA by or on behalf of the employer.",
        },
        {
          code: "K.2",
          machine_name: "k2_prep_first",
          widget: "text",
          label: "First (given) Name",
          validate: [
            {
              valueChecker: "k2_prep_first",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: ["k1_prep_last", "k2_prep_first", "k3_prep_middle", "k4_prep_firm_name", "k5_prep_email"],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the first (given) name of the person preparing this LCA by or on behalf of the employer.",
        },
        {
          code: "K.3",
          machine_name: "k3_prep_middle",
          widget: "text",
          label: "Middle Initial",
          maxLength: 3,
          tooltip:
            "Enter the middle name of the person preparing this LCA by or on behalf of the employer, if a middle name exists.",
        },
        {
          code: "K.4",
          machine_name: "k4_prep_firm_name",
          widget: "text",
          label: "Firm/Business Name",
          validate: [
            {
              valueChecker: "k4_prep_firm_name",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: ["k1_prep_last", "k2_prep_first", "k3_prep_middle", "k4_prep_firm_name", "k5_prep_email"],
                check: "ifValueExists",
              },
            },
            {
              minLength: 5,
              message: "Legal Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: "Enter the Firm/Business name of the person preparing this LCA by or on behalf of the employer.",
        },
        {
          code: "K.5",
          machine_name: "k5_prep_email",
          widget: "text",
          label: "Email Address",
          validate: [
            {
              valueChecker: "k5_prep_email",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: ["k1_prep_last", "k2_prep_first", "k3_prep_middle", "k4_prep_firm_name", "k5_prep_email"],
                check: "ifValueExists",
              },
            },
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],

          maxLength: 100,
          tooltip:
            "Enter the e-mail address of the person preparing this LCA by or on behalf of the employer. The entry must be in the format name@emailaddress.top-level domain.",
        },
      ],
    },
  ],
};
